import { AnnotationMarkStates, AnnotationTypes } from '@atlaskit/adf-schema/annotation';
import { AnnotationUpdateEvent } from '@atlaskit/editor-common/types/emitter';
import { PageMode } from '@confluence/page-utils/entry-points/enums.ts';

export const resolveInlineCommentAnnotation = (
	annotationId: string,
	pageMode: PageMode,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	eventEmitter: any,
): void => {
	if (!eventEmitter) {
		return;
	}
	if (pageMode === PageMode.VIEW) {
		eventEmitter.emit(AnnotationUpdateEvent.SET_ANNOTATION_STATE, {
			[annotationId]: {
				id: annotationId,
				annotationType: AnnotationTypes.INLINE_COMMENT,
				state: AnnotationMarkStates.RESOLVED,
			},
		});
	} else {
		eventEmitter.emit('resolve', annotationId);
	}
};

export const unresolveInlineCommentAnnotation = (
	annotationId: string,
	pageMode: PageMode,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	eventEmitter: any,
): void => {
	if (!eventEmitter) {
		return;
	}
	if (pageMode === PageMode.VIEW) {
		eventEmitter.emit(AnnotationUpdateEvent.SET_ANNOTATION_STATE, {
			[annotationId]: {
				id: annotationId,
				annotationType: AnnotationTypes.INLINE_COMMENT,
				state: AnnotationMarkStates.ACTIVE,
			},
		});
	} else {
		eventEmitter.emit('unresolve', annotationId);
	}
};
